/**
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * Licensed under the BSD 3-Clause license.
 * For full license text, see LICENSE.txt file in the repo root or
 * https://opensource.org/licenses/BSD-3-Clause
 */
import React from 'react';

import styled from 'styled-components';
import styles from '../../../styles';

import QuickFind from '../../../../shared/components/QuickFind';
import Localized from '../../../../shared/components/Localized';
import { StatusKey } from '../../../components/Status/StatusKey.js';
import RegionFilter from './RegionFilter.js';

const Wrapper = styled.div`
`;

const QuickFindRow = styled.div`
  display: flex;
  align-items: center;

  margin: 0.75rem 1rem;

  @media (max-width: 767px) {
    flex-wrap: wrap;
    margin: 1.25rem;
  }
`;

export const ControlText = styled.div`
  flex: 0 0 auto;
  ${styles.fonts.baseSmall}

  @media (max-width: 767px) {
    width: 100%;
    padding-bottom: 0.5rem;
  }
`;

const StyledQuickFind = styled(QuickFind)`
  flex: 0 0 auto;
  margin-left: auto;

  @media (max-width: 767px) {
    width: 100%;
  }
`;

const StyledStatusKey = styled(StatusKey)`
  @media (max-width: 767px) {
    display: none;
  }
`;

const regionLabelObject = {
  modelName: 'service',
  modelKey: 'Region:',
  modelAttribute: 'label'
};

const StatusGridViewControls = ({ items,
  onQuickFindFocus, onQuickFindChange, onFilter,
    selectedRegions, selectedStacks, allTags, regionOptions }) => (
  <Wrapper>
    <RegionFilter name='region'
      labelObject={ regionLabelObject }
      onFilter={ onFilter } 
      selectedOptions={ selectedRegions }
      options= { regionOptions }/>
    { allTags && Object.entries(allTags).map(([key, value]) => {
      return <RegionFilter
        key={ key }
        name={ key }
        tagType={ key }
        options={ value.options }
        labelObject={ value.labelObject }
        onFilter={ value.onFilter }
        selectedOptions={ value.selectedOptions }/>
      })
    }
    <QuickFindRow>
      <StyledStatusKey />
      <StyledQuickFind
        onFocus={ onQuickFindFocus }
        onChange={ onQuickFindChange }/>
    </QuickFindRow>
  </Wrapper>
);

export default StatusGridViewControls;
